// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
    --fasterfirst-teal: #0a8080;
    --fasterfirst-teal-hover: #005c5c;
    --fasterfirst-bg: #fafafa;
    --fasterfirst-card-bg: #ffffff;
    --fasterfirst-text: #1c1c1c;
    --fasterfirst-subtext: #6b6b6b;
    --fasterfirst-border: #d6d6d6;
}

body {
    background-color: var(--fasterfirst-bg);
    color: var(--fasterfirst-text);
    font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif;
}

/* Sidebar */
.sidebar {
    background-color: #ffffff;
    border-right: 1px solid var(--fasterfirst-border);
}

.nav-link {
    color: var(--fasterfirst-text);
    font-weight: 500;
    padding: 0.75rem 1rem;
    border-radius: 4px;
    transition: background-color 0.2s;
}

.nav-link:hover {
    background-color: #f3f3f3;
    color: var(--fasterfirst-text);
}

.nav-link.active {
    background-color: #e5f4f3; /* Light teal bg */
    color: var(--fasterfirst-teal);
    font-weight: 600;
    border-left: 3px solid var(--fasterfirst-teal);
}

/* Buttons */
.btn-primary {
    background-color: var(--fasterfirst-teal);
    border-color: var(--fasterfirst-teal);
}

.btn-primary:hover {
    background-color: var(--fasterfirst-teal-hover);
    border-color: var(--fasterfirst-teal-hover);
}

.btn-outline-secondary {
    color: var(--fasterfirst-text);
    border-color: var(--fasterfirst-border);
}

.btn-outline-secondary:hover {
    background-color: #f3f3f3;
    color: var(--fasterfirst-text);
    border-color: var(--fasterfirst-border);
}

/* Cards */
.card {
    border: 1px solid var(--fasterfirst-border);
    border-radius: 4px;
    box-shadow: 0 2px 4px rgba(0,0,0,0.02);
    margin-bottom: 1rem;
}

.task-card {
    display: flex;
    align-items: center;
    padding: 1.25rem;
    background: #fff;
    border: 1px solid var(--fasterfirst-border);
    border-radius: 4px;
    margin-bottom: 0.75rem;
    box-shadow: 0 4px 12px rgba(28, 28, 28, 0.08);
}

.task-icon {
    margin-right: 1rem;
    color: #e57373; /* Example alert color */
}

.task-content {
    flex-grow: 1;
}

.task-title {
    font-weight: 600;
    margin-bottom: 0.25rem;
}

.task-desc {
    color: var(--fasterfirst-subtext);
    font-size: 0.875rem;
}

/* Header */
.top-nav {
    background-color: #ffffff;
    border-bottom: 1px solid var(--fasterfirst-border);
    padding: 0.75rem 1.5rem;
}

.search-bar {
    background-color: #f3f3f3;
    border: none;
    border-radius: 20px;
    padding: 0.5rem 1rem;
    width: 300px;
}

/* Brand */
.brand-text {
    font-weight: 800;
    text-transform: uppercase;
    letter-spacing: 0.5px;
    font-size: 1.1rem;
    font-family: 'Segoe UI', Roboto, Helvetica, Arial, sans-serif;
}
`, "",{"version":3,"sources":["webpack://./client/styles/theme.css"],"names":[],"mappings":"AAAA;IACI,2BAA2B;IAC3B,iCAAiC;IACjC,yBAAyB;IACzB,8BAA8B;IAC9B,2BAA2B;IAC3B,8BAA8B;IAC9B,6BAA6B;AACjC;;AAEA;IACI,uCAAuC;IACvC,8BAA8B;IAC9B,gGAAgG;AACpG;;AAEA,YAAY;AACZ;IACI,yBAAyB;IACzB,iDAAiD;AACrD;;AAEA;IACI,8BAA8B;IAC9B,gBAAgB;IAChB,qBAAqB;IACrB,kBAAkB;IAClB,iCAAiC;AACrC;;AAEA;IACI,yBAAyB;IACzB,8BAA8B;AAClC;;AAEA;IACI,yBAAyB,EAAE,kBAAkB;IAC7C,8BAA8B;IAC9B,gBAAgB;IAChB,8CAA8C;AAClD;;AAEA,YAAY;AACZ;IACI,yCAAyC;IACzC,qCAAqC;AACzC;;AAEA;IACI,+CAA+C;IAC/C,2CAA2C;AAC/C;;AAEA;IACI,8BAA8B;IAC9B,uCAAuC;AAC3C;;AAEA;IACI,yBAAyB;IACzB,8BAA8B;IAC9B,uCAAuC;AAC3C;;AAEA,UAAU;AACV;IACI,2CAA2C;IAC3C,kBAAkB;IAClB,sCAAsC;IACtC,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,gBAAgB;IAChB,gBAAgB;IAChB,2CAA2C;IAC3C,kBAAkB;IAClB,sBAAsB;IACtB,6CAA6C;AACjD;;AAEA;IACI,kBAAkB;IAClB,cAAc,EAAE,wBAAwB;AAC5C;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,gBAAgB;IAChB,sBAAsB;AAC1B;;AAEA;IACI,iCAAiC;IACjC,mBAAmB;AACvB;;AAEA,WAAW;AACX;IACI,yBAAyB;IACzB,kDAAkD;IAClD,uBAAuB;AAC3B;;AAEA;IACI,yBAAyB;IACzB,YAAY;IACZ,mBAAmB;IACnB,oBAAoB;IACpB,YAAY;AAChB;;AAEA,UAAU;AACV;IACI,gBAAgB;IAChB,yBAAyB;IACzB,qBAAqB;IACrB,iBAAiB;IACjB,6DAA6D;AACjE","sourcesContent":[":root {\n    --fasterfirst-teal: #0a8080;\n    --fasterfirst-teal-hover: #005c5c;\n    --fasterfirst-bg: #fafafa;\n    --fasterfirst-card-bg: #ffffff;\n    --fasterfirst-text: #1c1c1c;\n    --fasterfirst-subtext: #6b6b6b;\n    --fasterfirst-border: #d6d6d6;\n}\n\nbody {\n    background-color: var(--fasterfirst-bg);\n    color: var(--fasterfirst-text);\n    font-family: -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, Helvetica, Arial, sans-serif;\n}\n\n/* Sidebar */\n.sidebar {\n    background-color: #ffffff;\n    border-right: 1px solid var(--fasterfirst-border);\n}\n\n.nav-link {\n    color: var(--fasterfirst-text);\n    font-weight: 500;\n    padding: 0.75rem 1rem;\n    border-radius: 4px;\n    transition: background-color 0.2s;\n}\n\n.nav-link:hover {\n    background-color: #f3f3f3;\n    color: var(--fasterfirst-text);\n}\n\n.nav-link.active {\n    background-color: #e5f4f3; /* Light teal bg */\n    color: var(--fasterfirst-teal);\n    font-weight: 600;\n    border-left: 3px solid var(--fasterfirst-teal);\n}\n\n/* Buttons */\n.btn-primary {\n    background-color: var(--fasterfirst-teal);\n    border-color: var(--fasterfirst-teal);\n}\n\n.btn-primary:hover {\n    background-color: var(--fasterfirst-teal-hover);\n    border-color: var(--fasterfirst-teal-hover);\n}\n\n.btn-outline-secondary {\n    color: var(--fasterfirst-text);\n    border-color: var(--fasterfirst-border);\n}\n\n.btn-outline-secondary:hover {\n    background-color: #f3f3f3;\n    color: var(--fasterfirst-text);\n    border-color: var(--fasterfirst-border);\n}\n\n/* Cards */\n.card {\n    border: 1px solid var(--fasterfirst-border);\n    border-radius: 4px;\n    box-shadow: 0 2px 4px rgba(0,0,0,0.02);\n    margin-bottom: 1rem;\n}\n\n.task-card {\n    display: flex;\n    align-items: center;\n    padding: 1.25rem;\n    background: #fff;\n    border: 1px solid var(--fasterfirst-border);\n    border-radius: 4px;\n    margin-bottom: 0.75rem;\n    box-shadow: 0 4px 12px rgba(28, 28, 28, 0.08);\n}\n\n.task-icon {\n    margin-right: 1rem;\n    color: #e57373; /* Example alert color */\n}\n\n.task-content {\n    flex-grow: 1;\n}\n\n.task-title {\n    font-weight: 600;\n    margin-bottom: 0.25rem;\n}\n\n.task-desc {\n    color: var(--fasterfirst-subtext);\n    font-size: 0.875rem;\n}\n\n/* Header */\n.top-nav {\n    background-color: #ffffff;\n    border-bottom: 1px solid var(--fasterfirst-border);\n    padding: 0.75rem 1.5rem;\n}\n\n.search-bar {\n    background-color: #f3f3f3;\n    border: none;\n    border-radius: 20px;\n    padding: 0.5rem 1rem;\n    width: 300px;\n}\n\n/* Brand */\n.brand-text {\n    font-weight: 800;\n    text-transform: uppercase;\n    letter-spacing: 0.5px;\n    font-size: 1.1rem;\n    font-family: 'Segoe UI', Roboto, Helvetica, Arial, sans-serif;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
